export default class MegaMenu {
    constructor ( items, menuItems ) {
        if (0 === items.length || 'object' !== typeof items) {
            // Nothing to see here.
            return;
        }

        this.activeClass = 'mega-menu--open';
        this.activeItem = null;
        this.timeOut = null;
        this.timeOutDuration = 1500;
        this.menuItems = menuItems;

        Array.from( items ).forEach( item => {
            item.addEventListener('mouseenter', () => this.megaMenuMouseEnter(item), true);
            item.addEventListener('mouseleave', () => {
                this.timeOut = setTimeout(() => this.closeMegaMenu(item), this.timeOutDuration);
            }, true);
        } );
    }

    /**
     * Fire events on `mouseenter`, closing other active mega-menu's and set current active.
     *
     * @param {object} item, The `.menu-item`.
     */
    megaMenuMouseEnter (item) {
        this.activeItem = item;
        [...this.menuItems].filter(el => el !== this.activeItem).forEach(el => setTimeout(() => {
            this.timeOut = setTimeout(() => this.closeMegaMenu(el), Math.floor(this.timeOutDuration / 5));
        }));
        this.activeItem.classList.add(this.activeClass);
    }

    /**
     * Close megaMenu.
     * @param {object} item, The `.menu-item`.
     */
    closeMegaMenu (item) {
        if (item.classList.contains(this.activeClass)) {
            item.classList.remove(this.activeClass);
        }
        clearTimeout(this.timeOut);
    }
}
